module.exports = __webpack_public_path__ + "img/微信图片_20211103160410.62475584.png";